"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformedSchema = transformedSchema;
const zod_1 = require("zod");
/**
 * The schema a transform or preprocess wraps. zod 4 writes both as a pipe
 * with a ZodTransform on one side: `.transform()` pipes into it, `preprocess`
 * starts with it. Null for a pipe of two schemas.
 */
function transformedSchema(pipe) {
    if (pipe.out instanceof zod_1.z.ZodTransform)
        return pipe.in;
    if (pipe.in instanceof zod_1.z.ZodTransform)
        return pipe.out;
    return null;
}
